<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useListItem } from "@/hooks";
import MpIcon from "./MpIcon.vue";

defineProps<{ buttonText?: string }>();
const { item, index } = useListItem();
const emit = defineEmits(["click"]);

function onClick(evt: any) {
  emit("click", evt);
}
</script>
<template>
  <MpIcon
    class="mp-list-icon"
    v-bind="$attrs"
    @click.stop="onClick({ item, index })"
  />
</template>
